import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class HomeDetailService {
  constructor(public http: HttpClient) {}

  getHomeDetail() {
    const url = environment.apiUrl + "/WebContentManager/ByPage/Home";
    return this.http.get(url);
  }
}
